var exports = {
  "Nr": "StreamSpectatorsPopout.module__card___YkFtSl",
  "wx": "StreamSpectatorsPopout.module__header___YkFtSl",
  "p_": "StreamSpectatorsPopout.module__list___YkFtSl",
  "QC": "StreamSpectatorsPopout.module__spectatorRow___YkFtSl",
  "zh": "StreamSpectatorsPopout.module__spectatorName___YkFtSl",
  "e": "StreamSpectatorsPopout.module__spectatorDevice___YkFtSl",
};

module.exports = exports;
